import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import Strings from "../../../Config/Strings";
import { addProductsAPI } from "../../../Store/Action/productAction";
import Colors from "../../../theme/Colors";
import ProductForm from "./Controls/ProductForm";

const AddProducts = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/productList", text: "Products" },
      { key: "2", href: "/addProducts", text: "Add Products" },
    ]);
  }, []);

  const onSubmit = async (formData) => {
    const formDataObject = {};
    formData.forEach((value, key) => {
      formDataObject[key] = value;
    });
    try {
      await dispatch(
        addProductsAPI(formDataObject, (isSuccess, response) => {
          if (isSuccess) {
            toast.success(response?.data?.message);
            navigate("/productList");
          } else {
            const errorMessage =
              response?.error?.message || Strings.somethingWentWrongError;
            toast.error(errorMessage);
          }
        })
      );
    } catch (error) {
      console.log("Error dispatching addProducts:", error);
      toast.error(Strings.somethingWentWrongError);
    }
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "20% 85%",
        height: "100vh",
        width: "100vw",
        overflowX: "hidden",
        overflowY: "hidden",
      }}
    >
      <LeftSideNav />
      <div
        style={{
          display: "grid",
          gridTemplateRows: "15% 83%",
          backgroundColor: Colors.bgColor,
        }}
      >
        <div style={{width: '94%'}}>
          <TopNavBar leftSideText={"Add Product"} />
          <BreadcrumbsComponent breadcrumbs={breadcrumbs} />  
        </div>

        <TableContainer
          component={Paper}
          style={{
            width: "91%",
            borderRadius: "6px",
            paddingLeft: "20px",
            paddingRight: "20px",
            marginLeft: "25px",
          }}
        >
          <ProductForm onSubmit={onSubmit} />
        </TableContainer>
      </div>
    </div>
  );
};

export default AddProducts;
